<script setup>
import WootReports from './components/WootReports.vue';
</script>

<template>
  <WootReports
    key="agent-reports"
    type="agent"
    getter-key="agents/getAgents"
    action-key="agents/get"
    header-icon="i-lucide-user"
    header-accent="slate"
    :download-button-label="$t('REPORT.DOWNLOAD_AGENT_REPORTS')"
    :report-title="$t('AGENT_REPORTS.HEADER')"
    :report-subtitle="$t('AGENT_REPORTS.DESCRIPTION')"
  />
</template>
